import { render, staticRenderFns } from "./assistant.vue?vue&type=template&id=3049504d&scoped=true&"
import script from "./assistant.vue?vue&type=script&lang=js&"
export * from "./assistant.vue?vue&type=script&lang=js&"
import style0 from "./assistant.vue?vue&type=style&index=0&id=3049504d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3049504d",
  null
  
)

export default component.exports